import React, { useEffect, useState, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import "../styles/UserAccountActivation.css";

const UserAccountActivation = () => {
	const { token } = useParams();
	const [message, setMessage] = useState("Trwa aktywacja konta...");
	const [loading, setLoading] = useState(true);
	const activated = useRef(false);

	useEffect(() => {
		if (activated.current) return;
		activated.current = true;

		const activate = async () => {
			try {
				const res = await fetch(
					`${process.env.REACT_APP_API_URL}/api/auth/activate/${token}`
				);
				const data = await res.json();

				if (res.ok) {
					setMessage("Konto zostało aktywowane! Możesz się teraz zalogować.");
				} else {
					setMessage(data.message || "Nie udało się aktywować konta.");
				}
			} catch (err) {
				setMessage("Błąd połączenia z serwerem.");
			} finally {
				setLoading(false);
			}
		};

		activate();
	}, [token]);

	const isError = message.toLowerCase().includes("nie") || message.toLowerCase().includes("błąd");

	return (
		<div className="activation">
			<div className="activationOverlay">
				<div className="activationCard">
					<h1>Aktywacja konta</h1>

					{loading ? (
						<p className="activationLoading">
							Proszę czekać, weryfikujemy Twój token...
						</p>
					) : (
						<>
							<p className={`activationMessage ${isError ? "error" : "success"}`}>
								{message}
							</p>

							<Link to="/login" className="activationLink">
								Przejdź do logowania
							</Link>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default UserAccountActivation;
